import { ChangeDetectorRef, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { FloatLabelModule } from 'primeng/floatlabel';
import { FluidModule } from 'primeng/fluid';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { PasswordModule } from 'primeng/password';
import { createDashboardRoute } from '../../../constants/route_generation';
import { Auth } from '../../../services/auth';

@Component({
  selector: 'app-login',
  imports: [
    CardModule,
    FormsModule,
    ButtonModule,
    InputTextModule,
    FloatLabelModule,
    FluidModule,
    DividerModule,
    InputGroupModule,
    InputGroupAddonModule,
    MessageModule,
    PasswordModule,
  ],
  templateUrl: './login.html',
  styleUrl: './login.css',
})
export class Login {
  user = {
    username: '',
    password: '',
  };

  errorMessage: string | undefined;
  isLoading: boolean = false;
  returnUrl = '/dashboard';

  constructor(
    private authService: Auth,
    private router: Router,
    private route: ActivatedRoute,
    private changeDetector: ChangeDetectorRef,
    private titleService: Title
  ) {
    this.returnUrl =
      this.route.snapshot.queryParamMap.get('returnUrl') || '/dashboard';
    titleService.setTitle('Login');
    if (this.authService.getCurrentUser()) {
      this.router.navigateByUrl(createDashboardRoute());
    }
  }

  onSubmit() {
    this.isLoading = true;
    this.authService.login(this.user.username, this.user.password).subscribe({
      next: (success) => {
        this.router.navigateByUrl(this.returnUrl);
      },
      error: (err) => {
        this.isLoading = false;
        this.errorMessage = 'Invalid username or password.';
        this.changeDetector.detectChanges();
      },
    });
  }
}
